import { useEffect, useRef } from 'react'

export const COMPLIANCE_CHANGED_EVENT = 'bp:compliance-changed'

export const notifyComplianceChanged = () => {
  try { window.dispatchEvent(new CustomEvent(COMPLIANCE_CHANGED_EVENT)) } catch { /* noop */ }
}

export const useComplianceChanged = handler => {
  const ref = useRef(handler)
  useEffect(() => { ref.current = handler })
  useEffect(() => {
    const fn = () => { if (ref.current) ref.current() }
    window.addEventListener(COMPLIANCE_CHANGED_EVENT, fn)
    return () => window.removeEventListener(COMPLIANCE_CHANGED_EVENT, fn)
  }, [])
}

export const useRefetchOnFocus = handler => {
  const ref = useRef(handler)
  useEffect(() => { ref.current = handler })
  useEffect(() => {
    let last = 0
    const run = () => {
      const now = Date.now()
      if (now - last < 2000) return
      last = now
      if (ref.current) ref.current()
    }
    const onVisibility = () => { if (document.visibilityState === 'visible') run() }
    window.addEventListener('focus', run)
    document.addEventListener('visibilitychange', onVisibility)
    return () => {
      window.removeEventListener('focus', run)
      document.removeEventListener('visibilitychange', onVisibility)
    }
  }, [])
}
